import { cloneDeep } from "lodash";
import {
  IResourceInfo,
  IResourceRequestBody,
  ResourceInfo,
} from "./ResourceEntity";

export type IResourceFloorPlanInfo = Record<string, any>

export interface IFloorPlanInfo {
  floorplanResponse: {
    path: string;
    additionalInfo: string;
  }
  externalResources: IResourceInfo[];
}

export class FloorPlanInfo {
  path: string;
  externalResources: ResourceInfo[] = [];

  constructor(data?: IFloorPlanInfo) {
    this.path = data?.floorplanResponse?.path || "";
    const resourceInfos: ResourceInfo[] = [];
    if (data?.externalResources?.length) {
      data.externalResources.forEach((item: IResourceInfo) => {
        item.resourceFloorPlanInfo = [];
        const itemClone = cloneDeep(item);
        const additionalInfos: IResourceFloorPlanInfo[] = JSON.parse(data?.floorplanResponse?.additionalInfo || "[]") as IResourceFloorPlanInfo[];
        additionalInfos.forEach((addInfo) => {
          if(item.guid === addInfo.data?.resourceId) {
            itemClone.resourceFloorPlanInfo = null;
            addInfo.data = new ResourceInfo(itemClone);
            item.resourceFloorPlanInfo?.push(addInfo)
          }
        })
        resourceInfos.push(new ResourceInfo(item));
      });
      this.externalResources = cloneDeep(resourceInfos);
    }
  }
}

export interface IFetchFloorPlanRequest {
  orgId: string;
  tenantId: string;
  requestBody: IFloorPlanRequestBody;
}

export interface IFloorPlanRequestBody extends IResourceRequestBody {
  LocationId: string;
}
